import * as React from "react";
import styles from "./steps.module.scss";

interface IStep {
  title: string;
  description: string;
  image: string;
}

const Steps = () => {
  const steps: IStep[] = [
    {
      title: "Deep Extraction",
      description:
        "No matter how often you wash your face, it can be nearly impossible to clear out your pores. It’s not you, <strong>it’s the tools you’re using</strong>. Most products can clean your pores somewhat, but blackheads and whiteheads still remain left under the surface. The magic with CeroFace is that it will go deep and extract <strong>everything</strong> that is blocking your pores.",
      image: 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585414137/ceroface/step-1.jpg'
    },
    {
      title: "Instant Treatments",
      description:
        "No more slathering on facemasks and waiting for them to dry only to <strong>just remove 30%</strong> of your blackheads. The beauty of CeroFace is how <strong>quick and easy</strong> it is. With your pores open, turn on the device and run it along your problem areas. The suction power will lift contaminants from deep within your pores instantly. ",
      image: 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585600239/ceroface/91737489_1340488852801448_5590531897231933440_n.jpg'
    },
    {
      title: "Safe To Use",
      description:
        "CeroFace is an easy, <strong>no-mark solution</strong> that leaves your skin <strong>clean and clear</strong> without a trace of its suction power. You won’t have any red marks or blemishes left by the gentle device, but your face will look the clearest it has in forever! Use it as a part of your normal beauty routine and <strong>enjoy a clear complexion daily!</strong>",
      image: 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585600238/ceroface/step-3.jpg'
    }
  ];

  return (
    <div className={styles.steps}>
      <h2>Clear Skin In 3 Easy Steps</h2>
      <div className={styles.stepsContent}>
        {steps.map((step: IStep, i: number) =>
          i % 2 === 0 ? (
            <div key={step.title} className={styles.step}>
              <img src={step.image} alt={step.title} />
              <div className={styles.text}>
                <div className={styles.title}>
                  <div className={styles.number}>{i + 1}</div>
                  <h2>{step.title}</h2>
                </div>
                <p dangerouslySetInnerHTML={{ __html: step.description }} />
              </div>
            </div>
          ) : (
            <div key={step.title} className={styles.step}>
              <div className={styles.text}>
                <div className={styles.title}>
                  <div className={styles.number}>{i + 1}</div>
                  <h2>{step.title}</h2>
                </div>
                <p dangerouslySetInnerHTML={{ __html: step.description }} />
              </div>
              <img src={step.image} alt={step.title} />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Steps;
